if (!customElements.get('mo-empty-discovery')) {
  customElements.define('mo-empty-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[data-mo-tab]')];
      this.panels = [...this.querySelectorAll('[data-mo-panel]')];
      this.arrows = [...this.querySelectorAll('[data-mo-scroll]')];
      this.select('books');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.moTab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(this.tabs[next].dataset.moTab);
          this.tabs[next].focus();
        });
      });
      this.panels.forEach(panel => panel.querySelector('.mo-empty-discovery__track').addEventListener('scroll', () => this.updateArrows(), {passive: true}));
      this.arrows.forEach(button => button.addEventListener('click', () => {
        const track = this.activeTrack();
        track.scrollBy({left: Number(button.dataset.moScroll) * track.clientWidth * 0.85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this);
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
    activeTrack() { return this.panels.find(panel => !panel.hidden).querySelector('.mo-empty-discovery__track'); }
    select(key) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.moTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.moPanel !== key; });
      requestAnimationFrame(() => this.updateArrows());
    }
    updateArrows() {
      const track = this.activeTrack();
      this.arrows[0].disabled = track.scrollLeft <= 1;
      this.arrows[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
  });
}
